// extracted by mini-css-extract-plugin
export var boldText = "_5q-4";
export var checkboxContainer = "_5q-6";
export var closeIcon = "_5q-i";
export var container = "_5q-0";
export var drawer = "_5q-8";
export var drawerContent = "_5q-9";
export var extraSmallText = "_5q-5";
export var fulfillmentGroupTable = "_5q-e";
export var largeText = "_5q-3";
export var loadingSpinnerContainer = "_5q-j";
export var mediumText = "_5q-2";
export var narrow = "_5q-f";
export var notificationLink = "_5q-l";
export var packageCheckIconContainer = "_5q-7";
export var slideoutHeaderActions = "_5q-g";
export var slideoutHeaderActionsShifted = "_5q-h";
export var slideoutHeaderContainer = "_5q-a";
export var slideoutModal = "_5q-c";
export var stickyHeaderWrapper = "_5q-b";
export var table = "_5q-k";
export var tableContainer = "_5q-d";
export var tertiaryText = "_5q-1";